import type { FlowValidationProblem } from '../../types/negotiationAgents';

const agentSettingDocumentExtensions = ['.pdf', '.doc', '.docx', '.txt', '.md'];
const agentSettingDocumentLimitMb = 25;
const agentSettingDocumentLimitBytes = agentSettingDocumentLimitMb * 1024 * 1024;
const documentFormats = agentSettingDocumentExtensions.map((extension) =>
  extension.slice(1).toUpperCase(),
);
const documentFormatDescription = `${documentFormats.slice(0, -1).join(', ')} ou ${documentFormats.at(-1)}`;

export const agentSettingDocumentAccept = agentSettingDocumentExtensions.join(',');
export const agentSettingDocumentHelp = `${documentFormatDescription}, até ${agentSettingDocumentLimitMb} MB.`;

export function agentSettingDocumentError(file: File): FlowValidationProblem | null {
  if (
    !agentSettingDocumentExtensions.some((extension) => file.name.toLowerCase().endsWith(extension))
  )
    return {
      code: 'INVALID_DOCUMENT',
      message: `Tipo de documento não aceito. Use ${documentFormatDescription}.`,
    };
  if (file.size > agentSettingDocumentLimitBytes)
    return {
      code: 'INVALID_DOCUMENT',
      message: `O documento excede o limite de ${agentSettingDocumentLimitMb} MB.`,
    };
  if (file.size === 0)
    return { code: 'INVALID_DOCUMENT', message: 'Selecione um documento que não esteja vazio.' };
  return null;
}
